import { FilterOption } from '../../../components/_WMS/FilterComponent/types'
import {
  createBackendTransformer,
  createDisplayTransformer
} from '../../../types/filters'
import { WarehouseAutoCompleter } from './WarehouseAutoCompleter'

export const filterOptions: FilterOption[] = [
  {
    key: 'warehouseCode',
    label: 'Código de Almacén',
    type: 'text',
    order: 1
  },
  {
    key: 'warehouseId',
    label: 'Nombre',
    type: 'custom',
    Component: WarehouseAutoCompleter,
    order: 2,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    key: 'supplierId',
    label: 'Proveedor',
    type: 'precreated',
    order: 3
  },
  {
    key: 'active',
    label: 'Activo',
    type: 'precreated',
    order: 4
  }
]
